import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const isAdmin = cfg.url && (cfg.url.startsWith("/admin") || cfg.url === "/auth/me");
    if (err.response?.status === 401 && isAdmin && !cfg._retried) {
      cfg._retried = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => (refreshing = null));
      try {
        await refreshing;
        return api(cfg);
      } catch (e) {
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  }
);

export function errText(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.response?.status === 429 ? "Too many attempts — please wait a few minutes." : fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg || "").replace(/^Value error, /, "")).filter(Boolean).join(". ");
  return d.msg || fallback;
}

export const mediaUrl = (u) => (!u ? "" : u.startsWith("/api") ? `${BACKEND}${u}` : u);
export const thumbUrl = (u) => (u && u.startsWith("/api/media/") ? mediaUrl(u.replace(/\.webp$/, "-640.webp")) : mediaUrl(u));
export const money = (n) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", minimumFractionDigits: 2 }).format(n || 0);

export const PORTAL_URL = "https://jorviktuning.co.uk/";
export const PHONE = "01756 532014";
export const PHONE_HREF = "tel:+441756532014";
export const EMAIL = "info@jorviktuning.com";
